import { anyPass, isEmpty, isNil, reject } from 'ramda';

/**
 * Removes empty keys from an object, An empty key is a key that is either `null`, `undefined`, empty object, empty array or an empty string.
 * This function does not remove keys with a value of `0` or `false`. Check https://ramdajs.com/docs/#empty for more information.
 *
 * @public
 *
 * @param data - The data to remove empty keys from
 *
 * @returns The data with empty keys removed, note that **empty arrays and empty objects are also removed**
 */
export function removeEmptyKeys<T extends Record<string, unknown>>(
  data: T,
): {
  [K in keyof T]: undefined extends T[K] ? T[K] | undefined : T[K];
} {
  return reject(anyPass([isNil, isEmpty]))(data);
}
